<template>
  <div class="mx-auto flex h-16 w-full max-w-6xl items-center justify-end px-4">
    <BaseLink
      v-if="loggedIn"
      class="text-muted-400 mx-4"
      to="/logout"
      rel="noopener"
    >
      {{ $t('login.button_log_out') }}
    </BaseLink>
  </div>
</template>

<script setup>
// import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

// const { t, locale } = useI18n()
// Get the store instance
const { clear: clearAuth, user, setUser } = useAuthStore()

const router = useRouter()
const { locale, t } = useI18n()

const loggedIn = ref(false)

// Create the logout/welcome message
const { $dataService } = useNuxtApp()
const logout = () => {
  $dataService
    .logout()
    .then(() => {
      // Clear the store
      clearAuth()
      // Redirect to Login
      router.push('/')
    })
    .catch(() => {})
}

watch(() => user.value, (val) => {
  // HACK: The references from the store don't want to work, so hacking it
  if (user.value.userId) {
    loggedIn.value = true
  }
})
</script>
